import React from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";

const ReplyPopup = ({
  isOpen,
  setisOpen,
  handleReply,
  onClose,
  ticketId,
  isSubmitting = false,
}) => {
  const validate = (values) => {
    const errors = {};

    if (!values.reply.trim()) {
      errors.reply = "Required";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      reply: "",
    },
    validate,
    onSubmit: async (values, { resetForm }) => {
      const sent = await handleReply(values.reply.trim());
      if (sent) resetForm();
    },
  });

  React.useEffect(() => {
    if (isOpen) formik.resetForm();
    // Reset for every open and every customer ticket change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, ticketId]);

  const closeReply = () => {
    formik.resetForm();
    setisOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={closeReply}
      role="dialog"
      aria-labelledby="reply-modal-title"
    >
      <form
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        onSubmit={formik.handleSubmit}
      >
        <h2 className="modal-title" id="reply-modal-title">
          Write Reply
        </h2>
        <textarea
          name="reply"
          className="Auth_input"
          placeholder="Enter Reply..."
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.reply}
          disabled={isSubmitting}
        />
        {formik.touched.reply && formik.errors.reply ? (
          <p className="invalid">{formik.errors.reply}</p>
        ) : null}
        <div className="modal-buttons">
          <button
            type="button"
            className="cancel-btn"
            onClick={closeReply}
            style={{ margin: "25px 0" }}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-14"
            style={{ width: "80%" }}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Reply"}
          </button>
        </div>
      </form>
    </div>
  );
};

ReplyPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setisOpen: PropTypes.func.isRequired,
  handleReply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  ticketId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSubmitting: PropTypes.bool,
};

export default ReplyPopup;
